import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApplicationResponseModel } from '@global-models/Response/ApplicationResponseModel';
import { UserMessageResponseModel } from '@global-models/Response/UserMessageResponseModel';
import { UserShortcutResponseModel } from '@global-models/Response/UserShortcutResponseModel';
import { UserSettingResponseModel } from '@global-models/Response/UserSettingResponseModel';
import { SettingResponseModel } from '@global-models/Response/SettingResponseModel';
import { DashboardItemResponseModel } from '@global-models/Response/DashboardItemResponseModel';
import { TokenResponseModel } from '@auth-models/Response/TokenResponseModel';

@Component({
  selector: 'app-quick-sidebar',
  templateUrl: './quick-sidebar.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class QuickSidebarComponent implements OnInit {
  public token: TokenResponseModel = new TokenResponseModel();
  public _dashboardItemResponseModel: DashboardItemResponseModel = new DashboardItemResponseModel();

  constructor() { }

  ngOnInit() {
    if (localStorage.getItem('DashboardItems') !== null) {
      this._dashboardItemResponseModel = (JSON.parse(localStorage.getItem('DashboardItems')) as DashboardItemResponseModel);

      this._dashboardItemResponseModel.Settings.forEach((value) => {
        const setting = this._dashboardItemResponseModel.UserSettings.find(x => x.Id === value.Id);
        if (setting) {
          value.DefaultValue = setting.Value;
        }
      });

      if (this._dashboardItemResponseModel !== undefined && this._dashboardItemResponseModel !== null) {
        this.token = (JSON.parse(localStorage.getItem('DashboardToken')) as TokenResponseModel);
      } else {
        this._dashboardItemResponseModel = new DashboardItemResponseModel();
        this._dashboardItemResponseModel.Applications = new Array<ApplicationResponseModel>();
        this._dashboardItemResponseModel.UserMessages = new Array<UserMessageResponseModel>();
        this._dashboardItemResponseModel.UserShortcuts = new Array<UserShortcutResponseModel>();
        this._dashboardItemResponseModel.UserSettings = new Array<UserSettingResponseModel>();
        this._dashboardItemResponseModel.Settings = new Array<SettingResponseModel>();
      }

    } else {
      this._dashboardItemResponseModel = new DashboardItemResponseModel();
      this._dashboardItemResponseModel.Applications = new Array<ApplicationResponseModel>();
      this._dashboardItemResponseModel.UserMessages = new Array<UserMessageResponseModel>();
      this._dashboardItemResponseModel.UserShortcuts = new Array<UserShortcutResponseModel>();
      this._dashboardItemResponseModel.UserSettings = new Array<UserSettingResponseModel>();
      this._dashboardItemResponseModel.Settings = new Array<SettingResponseModel>();
    }

  }

}
